// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202604300136/js/" + chunkId + "." + {"44":"142c8863","225":"8b58accc","481":"a83d8a80","486":"bc5075cb","770":"f42badfd"}[chunkId] + ".0.9223700328796358.chunk.js";
};